import { config } from "../../modules/mcm-vue-components";

/**
 * This defines some colors and co for the Sennheiser theme
 */
export default {
  dark: false,
  ...config.theme,
};
